"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var react_1 = require("react");
var SvgDataCatalogLineageVirtualConnectionWhite = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, xmlns: "http://www.w3.org/2000/svg", role: "img" }, props),
    React.createElement("path", { d: "M19 4a1 1 0 0 1 1 1v3a.995.995 0 0 1-.134.501A.982.982 0 0 1 20 9v3a.995.995 0 0 1-.134.501A.982.982 0 0 1 20 13v3a1 1 0 0 1-1 1h-7v1.086c.436.154.778.502.924.941l-.01-.028L18 19v1h-5.086l.008-.022a1.5 1.5 0 0 1-2.796.124l-.04-.101L6 20v-1l4.086-.001-.01.028c.146-.439.489-.788.924-.942V17H5a1 1 0 0 1-1-1v-3c0-.182.049-.353.134-.5A.993.993 0 0 1 4 12V9c0-.182.049-.353.134-.5A.993.993 0 0 1 4 8V5a1 1 0 0 1 1-1h14Zm-7.5 15a.5.5 0 1 0 0 1 .5.5 0 0 0 0-1Zm5.5-6H5v3h14v-3h-1v1h-1v-1Zm0-4H5v3h14V9h-1v1h-1V9Zm0-4H5v3h14V5h-1v1h-1V5Z", fill: "#FFF", fillRule: "evenodd" }))); };
var Memo = (0, react_1.memo)(SvgDataCatalogLineageVirtualConnectionWhite);
exports.default = Memo;
//# sourceMappingURL=DataCatalogLineageVirtualConnectionWhite.js.map